import React, { useEffect, useRef, useState } from 'react'
import lottie from 'lottie-web'

const LottieAnimationLoadable = ({ path, animationData, autoplay = false, loop = false, playStart, play }) => {
  const lottieRef = useRef(null)
  const [loadedAnimation, setLoadedAnimation] = useState(null)

  useEffect(() => {
    if (path || animationData) {
      setLoadedAnimation(
        lottie.loadAnimation({
          container: lottieRef.current,
          renderer: 'svg',
          path,
          animationData,
          loop,
          autoplay,
        })
      )
    }
    return () => {
      if (loadedAnimation) {
        loadedAnimation.destroy()
      }
    }
  }, [])

  useEffect(() => {
    if (playStart) {
      if (loadedAnimation) {
        loadedAnimation.play()
      }
    }
  }, [playStart, loadedAnimation])

  useEffect(() => {
    if (loadedAnimation && loadedAnimation.isLoaded && play) {
      loadedAnimation.goToAndPlay(0)
    }
  }, [loadedAnimation, play])

  return <div ref={lottieRef} />
}

export default LottieAnimationLoadable
